import { Modal, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

/**
 * 《用户协议》与《隐私政策》弹窗组件（通用型规范文档，符合中国法律法规与主流平台要求）
 * 依据：民法典、网络安全法、数据安全法、个人信息保护法、电子商务法、电信条例、工信部相关规定
 */

export const USER_AGREEMENT_TEXT = (
  <div style={{ maxHeight: 420, overflowY: 'auto', paddingRight: 8 }}>
    <Title level={5}>DTwince 云边智孪 用户协议</Title>
    <Paragraph type="secondary">版本：v1.0　生效日期：2026年9月</Paragraph>
    <Paragraph>欢迎使用 DTwince 云边智孪（以下简称"本平台"）。本协议是您与本平台运营方（以下简称"我们"）之间就使用本平台服务所订立的协议。请您在使用本平台前仔细阅读并充分理解本协议全部内容，特别是免除或限制责任的条款、法律适用和争议解决条款。**您勾选"我已阅读并同意《用户协议》与《隐私政策》"即视为您已阅读并同意本协议的全部内容。**</Paragraph>

    <Title level={5}>一、服务内容</Title>
    <Paragraph>
      1.1 本平台提供数字孪生场景搭建、可视化大屏设计、设备数据接入与管理等相关功能服务，具体以平台实际提供的功能为准。<br />
      1.2 我们可能根据业务发展需要调整、变更、暂停或终止部分服务功能，并将以合理方式通知您。
    </Paragraph>

    <Title level={5}>二、账号注册与管理</Title>
    <Paragraph>
      2.1 您应使用真实、合法、有效的手机号码注册账号，并保证注册信息的真实性、准确性、完整性。注册信息如有变更，您应及时更新。<br />
      2.2 您的账号仅限本人使用，**不得出借、出租、转让、售卖账号或与他人共享**。因您保管不善导致账号被盗用、数据泄露的，由您自行承担责任。<br />
      2.3 您应对以您的账号进行的全部操作行为负责。发现账号被他人冒用或存在安全漏洞时，应立即通知我们并采取相应措施。<br />
      2.4 我们有权对违反法律法规或本协议约定的账号采取限制、冻结或注销等措施。
    </Paragraph>

    <Title level={5}>三、用户行为规范</Title>
    <Paragraph>
      3.1 您承诺遵守国家法律法规，不得利用本平台从事任何违法活动，包括但不限于：制作、复制、发布、传播含有下列内容的信息：危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视的；破坏国家宗教政策、宣扬邪教和封建迷信的；散布谣言、扰乱社会秩序、破坏社会稳定的；侮辱诽谤他人、侵害他人合法权益的；含有虚假、欺诈、侵害第三方知识产权内容的。<br />
      3.2 您不得利用本平台从事任何危害平台安全的行为，包括但不限于：非法侵入、破坏、干扰平台系统的正常运行；攻击、破解、绕过平台的安全防护措施；恶意抓取、批量下载平台数据。<br />
      3.3 您上传、发布、存储于本平台的场景、大屏、数据等内容，应确保拥有合法权利或已获得合法授权，不侵犯任何第三方的合法权益。
    </Paragraph>

    <Title level={5}>四、知识产权</Title>
    <Paragraph>
      4.1 本平台及提供的软件、技术、界面、图标、文档等所有内容的知识产权归我们或相应权利人所有。<br />
      4.2 您上传至平台的场景、模型、数据等内容的知识产权归您或原始权利人所有。您授权我们在提供服务所必需的范围内使用、存储、处理这些内容。<br />
      4.3 未经权利人书面许可，您不得复制、传播、修改、反编译本平台的软件或服务。
    </Paragraph>

    <Title level={5}>五、数据与个人信息</Title>
    <Paragraph>
      5.1 我们重视并依法保护您的个人信息，具体处理规则详见《隐私政策》。<br />
      5.2 您应对上传至平台的业务数据自行负责，包括数据的合法性、准确性及所涉第三方的同意与授权。
    </Paragraph>

    <Title level={5}>六、服务的变更、中断与终止</Title>
    <Paragraph>
      6.1 鉴于互联网服务的特殊性，我们可能因系统维护、升级、故障等原因暂停服务，并将尽合理努力提前通知。<br />
      6.2 如您违反本协议约定，我们有权视情节轻重采取警示、限制功能、暂停服务、封禁账号等措施。
    </Paragraph>

    <Title level={5}>七、免责声明</Title>
    <Paragraph>
      7.1 因不可抗力、第三方原因（如网络故障、运营商问题）、您的设备或操作原因导致的损失，我们不承担责任。<br />
      7.2 您使用第三方服务（如通过平台接入的外部系统）产生的风险由您自行承担。
    </Paragraph>

    <Title level={5}>八、协议变更</Title>
    <Paragraph>我们可能适时修订本协议。协议变更后，我们将以适当方式（如站内公告、弹窗提示等）通知您。若您不同意变更内容，有权停止使用服务；继续使用即视为接受修订后的协议。</Paragraph>

    <Title level={5}>九、法律适用与争议解决</Title>
    <Paragraph>本协议的订立、执行、解释及争议解决均适用中华人民共和国法律。因本协议产生的争议，双方应友好协商解决；协商不成的，任何一方可向平台运营方所在地有管辖权的人民法院提起诉讼。</Paragraph>

    <Title level={5}>十、联系我们</Title>
    <Paragraph>如您对本协议有任何疑问、意见或建议，请通过平台公布的联系方式与我们联系。</Paragraph>
  </div>
);

export const PRIVACY_POLICY_TEXT = (
  <div style={{ maxHeight: 420, overflowY: 'auto', paddingRight: 8 }}>
    <Title level={5}>DTwince 云边智孪 隐私政策</Title>
    <Paragraph type="secondary">版本：v1.0　生效日期：2026年9月</Paragraph>
    <Paragraph>
      我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。本政策将向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您所享有的相关权利。**请您在使用本平台前仔细阅读并充分理解本政策。** 我们仅在法律法规允许的范围内、以提供服务所必需为限处理您的个人信息。
    </Paragraph>

    <Title level={5}>一、我们收集的信息</Title>
    <Paragraph>
      1.1 <Text strong>账号信息</Text>：您注册时提供的手机号码，以及您主动填写的昵称、邮箱等联系方式。<br />
      1.2 <Text strong>设备与日志信息</Text>：为保障服务安全和运行稳定，我们可能收集您的设备信息（设备型号、操作系统版本、浏览器类型）、IP地址、访问时间、操作记录等日志信息。<br />
      1.3 <Text strong>业务数据</Text>：您在使用本平台过程中创建、上传的场景、大屏、模型、设备数据源等业务内容。<br />
      1.4 <Text strong>认证信息</Text>：为完成短信验证等安全认证，我们可能处理您的短信验证码校验信息（验证码本身不存储明文）。
    </Paragraph>

    <Title level={5}>二、我们如何使用信息</Title>
    <Paragraph>
      2.1 提供、维护和改进本平台的服务功能；<br />
      2.2 进行身份验证、账号管理、安全防护（如防爆破、反欺诈）；<br />
      2.3 处理您提交的注册、登录、密码重置、手机号变更等请求；<br />
      2.4 向您发送服务通知（如订阅到期提醒、安全提醒）；<br />
      2.5 法律法规允许的其他用途。
    </Paragraph>

    <Title level={5}>三、信息的存储与保护</Title>
    <Paragraph>
      3.1 您的个人信息将存储于中华人民共和国境内。除法律法规另有规定或您另行授权外，我们不会跨境传输您的个人信息。<br />
      3.2 我们采取符合行业标准的安全措施保护您的个人信息，包括但不限于加密传输（HTTPS）、加密存储（密码哈希）、访问控制、安全审计等。<br />
      3.3 我们仅在实现服务目的所必需的期限内保留您的个人信息。业务数据在您主动删除或账号注销后按约定处理。
    </Paragraph>

    <Title level={5}>四、信息的共享与对外提供</Title>
    <Paragraph>
      4.1 我们不会向任何第三方出售您的个人信息。<br />
      4.2 除以下情形外，我们不会对外共享您的个人信息：<br />
      （1）获得您的明确同意或授权；<br />
      （2）根据法律法规要求、司法或行政机关的强制性要求；<br />
      （3）为提供服务所必需，向为我们提供技术服务的合作方提供（该等合作方同样受到保密义务约束）；<br />
      （4）在涉及合并、收购、资产转让等情形时，我们会要求继受方继续受本政策约束。
    </Paragraph>

    <Title level={5}>五、您的权利</Title>
    <Paragraph>
      依据《中华人民共和国个人信息保护法》，您享有以下权利：<br />
      5.1 <Text strong>查询与更正</Text>：您可以查询、更正您的账号信息。<br />
      5.2 <Text strong>删除</Text>：您可以删除您的账号及业务数据。<br />
      5.3 <Text strong>撤回同意</Text>：您可以撤回对个人信息处理的同意。<br />
      5.4 <Text strong>注销账号</Text>：您可以通过联系我们申请注销账号，注销后我们将依法删除或匿名化处理您的个人信息。<br />
      5.5 您可以通过平台"个人中心"或联系我们行使上述权利。
    </Paragraph>

    <Title level={5}>六、Cookie 及同类技术</Title>
    <Paragraph>我们可能使用 Cookie 及同类技术以保障服务正常运行、提升使用体验、开展安全防护。您可以通过浏览器设置管理或禁用 Cookie，但可能影响部分功能的使用。</Paragraph>

    <Title level={5}>七、未成年人保护</Title>
    <Paragraph>本平台主要面向成年人提供服务。如您是未成年人，应在监护人指导下使用本平台，并取得监护人的同意。</Paragraph>

    <Title level={5}>八、政策更新</Title>
    <Paragraph>我们可能适时修订本政策。重大变更将以适当方式通知您。继续使用服务即视为接受更新后的政策。</Paragraph>

    <Title level={5}>九、联系我们</Title>
    <Paragraph>如您对本政策有任何疑问、意见或建议，或需行使个人信息相关权利，请通过平台公布的联系方式与我们联系，我们将在收到请求后15个工作日内予以答复。</Paragraph>
  </div>
);

/** 通用协议弹窗：title + content，open/onCancel 受控 */
export function AgreementModal(props: {
  open: boolean;
  title: string;
  content: React.ReactNode;
  onCancel: () => void;
}) {
  return (
    <Modal open={props.open} title={props.title} footer={null} width={720} onCancel={props.onCancel}>
      {props.content}
    </Modal>
  );
}